import { api, API_BASE } from './apiClient';
import type { LiveTvChannel } from '@/types/livetv';

/**
 * Absolute master-playlist URL for a channel. HLS.js loads this directly and
 * resolves the rewritten proxy segment URLs in the body against it — same
 * pattern as buildSportsPlaylistUrl.
 */
export function buildLiveTvPlaylistUrl(channelId: string): string {
  return `${API_BASE}/api/livetv/${encodeURIComponent(channelId)}/playlist.m3u8`;
}

export const livetvApi = {
  /** A 200 means the Live TV section is enabled on the backend (the router is
   *  unmounted when STREAMING_LIVETV_ENABLED is off, so this 404s when off). */
  enabled(): Promise<{ enabled: boolean }> {
    return api<{ enabled: boolean }>('/api/livetv/enabled', { auth: true });
  },

  listChannels(): Promise<{ channels: LiveTvChannel[] }> {
    return api<{ channels: LiveTvChannel[] }>('/api/livetv/channels', { auth: true });
  },

  getChannel(channelId: string): Promise<{ channel: LiveTvChannel }> {
    return api<{ channel: LiveTvChannel }>(
      `/api/livetv/channels/${encodeURIComponent(channelId)}`,
      { auth: true },
    );
  },
};
